import { Entrega, Envio, Estado, Mayorista2Modo, Op, TipoOperacion } from "./entidades";
import { Precios } from "./producto.model";

export class ProductoList{
    id: string;
    nombre: string;
    foto: string;
    cantidad: number;
    stock: number;
    tipo: string;
    precio: Precios;
    marca?: string;
    descripcion?: string;

    constructor(data: any){
        this.id= data.id;
        this.nombre= data.nombre;
        this.foto = data.foto;
        this.cantidad= data.cantidad;
        this.stock = data.stock;
        this.tipo = data.tipo;
        this.precio= data.precio;
        this.marca = data.marca;
        this.descripcion = data.descripcion;
    }
}



/**
 * DTO equivalente a:
 * utunning.sgi.Ordenes.dominio.dto.OperacionDTO
 */
export interface OperacionDTO {
  /* ===== Identidad ===== */
  id?: number;

  /* ===== Relaciones por ID (entrada / persistencia) ===== */
  vendedorId?: number;
  clienteId?: number;
  usuarioBorraId?: number;

  /* ===== Relaciones enriquecidas (salida) ===== */
  vendedor?: UsuarioResumeDTO;
  cliente?: UsuarioResumeDTO;
  usuarioBorra?: UsuarioResumeDTO;

  /* ===== Fechas ===== */
  /** yyyy-MM-dd HH:mm:ss */
  fecha?: string;
  ingreso?: string;

  /* ===== Importes ===== */
  total?: number;
  subtotal?: number;
  descuento?: number;
  resto?: number;
  costoTotal?: number;
  gananciaTotal?: number;

  /* ===== Estado / tipo ===== */
  operacion?: Op;
  estado?: Estado;
  envio?: Envio;
  entrega?: Entrega;
  tipoOperacion?: TipoOperacion;

  facturado?: boolean;
  tipoPrecio?: TipoPrecio;
  may2Modo?: Mayorista2Modo;

  saphirusAplicado?: boolean;

  /* ===== Detalle ===== */
  productos?: ProductoOperacionDTO[];
  pagos?: PagosDTO[];
}

/* ========================================================= */
/* ===================== DETALLE =========================== */
/* ========================================================= */

export interface ProductoOperacionDTO {
  id?: string;

  /* Relaciones */
  productoId?: string;
  operacionId?: number;

  /* Valores */
  precio?: number;
  cantidad?: number;
  subtotal?: number;
  ganancia?: number;
  gananciaUnitaria?: number;
  costoUnitario?: number;
  costoTotal?: number;

  tipoPrecioItem?: TipoPrecioItem;
  preciosDTO?: PreciosDTO;

  /* Metadata */
  /** yyyy-MM-dd HH:mm:ss */
  fecha?: string;
  nombre?: string;
  tipo?: string;
}

/* ========================================================= */

export interface PagosDTO {
  id?: string;

  /** yyyy-MM-dd HH:mm:ss */
  fecha?: string;

  divisa?: Divisa;
  monto?: number;

  operacion_id?: number;
  usuario_id?: number;

  usuario?: UsuarioDTO;

  fechaDesde?: string;
  fechaHasta?: string;

  page?: number;
  detalle?: string;
}

/* ========================================================= */

export interface UsuarioResumeDTO {
  id?: number;
  nombre?: string;
  apellido?: string;
  num_Cliente?: string;

  tipo?: User;
  usuarioACargo?: UsuarioResumeDTO;
}

/* ========================================================= */
/* ======== DTOs mínimos referenciados (si no existen) ===== */
/* ========================================================= */

export interface PreciosDTO {
  costo?: number;
  publico?: number;
  may1?: number;
  may2?: number;
  may3?: number;
}

export interface UsuarioDTO {
  id?: number;
  nombre?: string;
  apellido?: string;
  mail?: string;
}

export enum User {
  EMPLEADO,
  GENERICO1,
  GENERICO2,
  PUBLICO,
  MAYORISTA,
  MAYORISTA2,
}

export enum Divisa {
  EFECTIVO,
  DEBITO,
  CREDITO,
  MERCADOPAGO,
  TRANSFERENCIA,
  CONTRAREEMBOLSO,
  TODAS,
  SUELDO,
}

export enum TipoPrecio {
  PUBLICO,
  MAYORISTA,
  MAYORISTA2,
  INTERNA,
}

export enum TipoPrecioItem {
  AUTO,
  MANUAL,
  SAPHIRUS,
}